export var rendererActionType;
(function (rendererActionType) {
    rendererActionType["DISPLAY_SCENE"] = "DISPLAY_SCENE";
    rendererActionType["ALERT"] = "ALERT";
})(rendererActionType || (rendererActionType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/rendererActionType.ts
// module id = 582
// module chunks = 50